import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AuditDTO } from "../models/AuditLog/AuditDTO";
import { AuditTableNameDTO } from "../models/AuditLog/AuditTableNameDTO";
import { AuditTypeDTO } from "../models/AuditLog/AuditTypeDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class AuditLogService {

    async GetAllAuditLog(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ) : Promise<PaginatedList<AuditDTO>>
    {
        try{
            var response = await APIService.Axios().post(`${APIService.GetURL()}/AuditLog/GetAll`,
            {
                searchParameters,
                sortingParameters,
                currentPage,
                pageSize,
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            },
            );
            return response.data;
        }catch(error)
        {
            return new PaginatedList<AuditDTO>(
                false,
                "Erro ao obter a informação do histórico",
                "",
                [],
                0,
            );
        }
    }

    async GetById(id: number): Promise<MessagingHelper<AuditDTO | null>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/AuditLog/${id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper(
                false,
                "Erro ao ligar ao servidor para ir buscar informação do histórico",
                null,
            );
        }
    }

    async GetAuditTypes(): Promise<MessagingHelper<AuditTypeDTO[]>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/AuditLog/GetAuditTypes`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + APIService.GetToken()
                }
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuditTypeDTO[]>(false, "Erro ao obter os tipos de AuditLog", []);
        };
    }

    async GetAuditTableNames(): Promise<MessagingHelper<AuditTableNameDTO[]>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/AuditLog/GetAuditTableNames`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + APIService.GetToken()
                }
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuditTableNameDTO[]>(false, "Erro ao obter os nomes das tabelas de AuditLog", []);
        };
    }
    
}
    
